import cx from 'classnames';
import { useContext } from 'react';
import { Paragraph } from '@/home/HeroCardsReturnUser/Cards/styles';
import useGetTradeInStatus from '~/components/home/hooks/useGetTradeStatus';
import TradeContext from '~/context/common/TradeContext';
import { nativeStcPayload } from '~/native/home/utils';
import { activeTradeStatuses, ctaMap, TradeStatus } from './constants';
import {
  DetailsWrapper,
  Image,
  ImageWrapper,
  TradeValue,
  YearMakeModelTrim
} from './Details.styles';

export default function Details() {
  const tradeStatus = useGetTradeInStatus();
  const hasTrade = tradeStatus !== TradeStatus.None;
  const { statusAgnosticTrade } = useContext(TradeContext);
  const { acquisitionName, make, model, trim, year, vehicleValue } =
    statusAgnosticTrade ?? {};
  const imgSrc = statusAgnosticTrade?.vehicleImages.mobileImage ?? '';
  const yearMakeModelTrim = `${year} ${make} ${model} ${trim}`;

  const showTradeValue = activeTradeStatuses[tradeStatus];

  return hasTrade ? (
    <div
      className={cx(
        'grid gap-16 m:grid-cols-[78px_1fr] m:grid-rows-none',
        showTradeValue ? 'grid-rows-[1fr_78px]' : 'grid-rows-[1fr_auto]',
        { 'row-span-2 m:col-span-2': hasTrade }
      )}
    >
      {imgSrc && (
        <ImageWrapper>
          <Image data-qa="trade-mobile-image" src={imgSrc} />
        </ImageWrapper>
      )}

      <DetailsWrapper
        data-qa="trade-details-wrapper"
        imgSrc={imgSrc}
        showValue={showTradeValue}
      >
        <YearMakeModelTrim showValue={showTradeValue} title={yearMakeModelTrim}>
          {yearMakeModelTrim}
        </YearMakeModelTrim>

        <div className={cx({ hidden: !showTradeValue })}>
          <span className="tl-body-m">Trade-in value:</span>

          <div className="flex flex-row justify-between">
            <TradeValue data-qa="trade-card-value">{`$${vehicleValue?.toLocaleString()}`}</TradeValue>
            <a
              className="self-end capitalize text-blue-6 tl-link-s"
              data-analytics-id="Home feed card"
              data-analytics-attributes={JSON.stringify({
                description: 'STC card',
                status: tradeStatus,
                cta: ctaMap[tradeStatus],
                item: 'view details'
              })}
              data-qa="Trade view offer details link"
              data-native-payload={nativeStcPayload}
              href={`/sell-my-car/hub/${acquisitionName}`}
            >
              view details
            </a>
          </div>
        </div>
      </DetailsWrapper>
    </div>
  ) : (
    <Paragraph data-qa="no-trade-paragraph">
      You decide to sell, trade, or track your value
    </Paragraph>
  );
}
